export default "__VITE_ASSET__KPpIEk1y__"